import { prefixObjectValues } from '../utils';

const form = {
  form: 'form',
  certNum: 'cert-num',
  certType: 'cert-type-select',
  medicalBoard: 'board-name-select',
  specialtyBoard: 'specialty-board-select',
  specialty: 'specialty-name-select',
  specialtyCert: 'specialty-cert-select',
  subSpecialtyCert: 'subspecialty-name-select',
  customMedicalBoard: 'custom-board-name-select',
  customSpecialtyBoard: 'custom-specialty-board-input',
  customSpecialty: 'custom-specialty-name-input',
  customSpecialtyCert: 'custom-specialty-cert-input',
  customSubSpecialtyCert: 'custom-subspecialty-name-input',
  origCertDate: 'orig-cert-date',
  recertDate: 'recert-date',
  expiryDate: 'expiry-date',
  status: 'status',
  active: 'active-flag',
  notes: 'notes-input',
  removeBtn: 'remove-btn',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
};

export default prefixObjectValues(form, 'board-certs-form');
